import React, { useState, useEffect } from "react";
//Redux
import { useDispatch } from "react-redux";
import { ConfigurationPanel } from "../..";
import { PaymentMethods } from "./paymentMethods";
import { Input } from "@delibrandev/utils";
import { Textarea } from "../../../../../../components/inputs/textarea";
import {
  createPaymentMethod,
  getPaymentsMethods,
  removePaymentMethod,
  toogleStatusPaymentMethod,
  updatePaymentMethod,
} from "../../../../../../api/configuration";
import { Button } from "@delibrandev/utils";
import { setAlert } from "../../../../../../reducers/userConfigSlice";
import { translateMessage } from "@delibrandev/utils/src/function";

export const PaymentsMethods = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);

  const query = async () => {
    const response = await getPaymentsMethods();
    if (response && !response.error) {
      setData(response.data);
    } else {
      setData([]);
    }
  };

  const create = async () => {
    const payload = {
      name: "Nuevo método de pago",
      description: "",
      instructions: "",
    };
    const response = await createPaymentMethod(payload);
    if (response && !response.error) {
      dispatch(setAlert(translateMessage(response?.message || "Bad request")));
      query();
    } else {
      dispatch(setAlert(translateMessage(response?.message || "Bad request")));
    }
  };

  const update = async (paymentMethodId, name = null, isActive = true) => {
    console.log("update: ", paymentMethodId);
    const payload = {
      name: name || document.getElementById(`paymentMethod-${paymentMethodId}`).value,
      description: document.getElementById(`details-${paymentMethodId}`).value,
      instructions: document.getElementById(`guide-${paymentMethodId}`).value,
      isActive: isActive,
    };
    console.log(payload);
    const response = await updatePaymentMethod(payload, paymentMethodId);
    if (response && !response.error) {
      query();
      dispatch(setAlert(translateMessage(response?.message || "Bad request")));
    } else {
      dispatch(setAlert(translateMessage(response?.message || "Bad request")));
    }
  };

  const toogleStatus = async (paymentMethodId) => {
    const payload = {};
    const response = await toogleStatusPaymentMethod(payload, paymentMethodId);
    if (response && !response.error) {
      query();
      dispatch(setAlert(translateMessage(response?.message || "Bad request")));
    } else {
      dispatch(setAlert(translateMessage(response?.message || "Bad request")));
    }
  };

  const deleteMethod = async (id) => {
    const response = await removePaymentMethod({}, id);
    if (response && !response.error) {
      query();
      dispatch(setAlert(translateMessage(response?.message || "Bad request")));
    } else {
      dispatch(setAlert(translateMessage(response?.message || "Bad request")));
    }
  };

  const EditionPanel = ({ data }) => {
    console.log("EditionPanel: ", data);
    const [isActive, toggleActive] = useState(data?.isActive);
    const handleActive = () => {
      toggleActive(!isActive);
    };
    const isDefault = data?.name === "Efectivo" || data?.name === "Tarjeta de crédito" ? true : false;
    return (
      <div className="row">
        <div className="col-12 mb-2">
          <div className="inputLabel" style={{ fontSize: "1rem", marginTop: "-20px", marginBottom: "15px" }}>
            {data?.name}
          </div>
          {!isDefault && (
            <Input
              id={"paymentMethod-" + data?.paymentMethodId}
              type={"text"}
              placeholder=""
              icon={null}
              classname={"w-100"}
              iconPositionRight={true}
              label="Nombre"
              description=""
              defaultValue={data?.name || ""}
            />
          )}
        </div>
        <div className="col-12 mb-2">
          <Textarea
            id={"details-" + data?.paymentMethodId}
            placeholder={data?.description}
            classname={""}
            label={"Detalles adiccionales"}
            description={""}
          />
        </div>
        <div className="col-12 mb-2">
          <Textarea
            id={"guide-" + data?.paymentMethodId}
            placeholder={data?.instructions}
            classname={""}
            label={"Instrucciones de pago"}
            description={""}
          />
        </div>
        <div className="col-12 mb-2">
          <input id={"active-" + data?.paymentMethodId} type="checkbox" onChange={handleActive} className="custom-checkbox" checked={isActive} />{" "}
          Activo
        </div>
        <div className="col-12 mb-2">
          <div className="row">
            <div className="col-6"></div>
            <div className="col-6 text-align-right flex-end">
              {data?.paymentMethodId !== "" && (
                <Button
                  key={"Activar"}
                  text={data?.isActive ? "Desactivar" : "Activar"}
                  icon={null}
                  action={() => toogleStatus(data?.paymentMethodId)}
                  customClass={"customButtonColor1"}
                />
              )}
              {!isDefault && (
                <Button
                  key={"Eliminar"}
                  text={"Eliminar"}
                  icon={null}
                  action={() => deleteMethod(data?.paymentMethodId)}
                  customClass={"customButtonRed"}
                />
              )}
              <Button
                key={"Guardar"}
                text={"Guardar"}
                icon={null}
                action={() =>
                  update(data?.paymentMethodId, data?.name === "Efectivo" || data?.name === "Tarjeta de crédito" ? data.name : null, isActive)
                }
                customClass={"customButtonColor2"}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  useEffect(() => {
    query();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <ConfigurationPanel title="Métodos de pago" content={<PaymentMethods create={create} />} hasButtonSave={false} />
      <div className="row">
        {data?.map((method) => (
          <div className="col-6" key={method.paymentMethodId || method.id}>
            <ConfigurationPanel title={<div></div>} content={<EditionPanel data={method} />} hasButtonSave={false} />
          </div>
        ))}
      </div>
    </>
  );
};
